import { useNavigate } from "react-router-dom";
import "./AssignmentSchool.css";
import axios from "axios";
import { useEffect, useState } from "react";

const AssignmentSchool = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [niosClassName, setNiosClassName] = useState([]);
  const [niosClassNameId, setNiosClassNameId] = useState("");
  const [allSubjects, setAllSubjects] = useState([]);
  const [allSubjectsId, setAllSubjectsId] = useState("");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [language, setLanguage] = useState("");

  // Fetch classes from API
  const getClasses = () => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        setNiosClassName(resp.data);
      })
      .catch((error) => {
        console.error("Error fetching classes:", error);
      });
  };

  // Fetch subjects when a class is selected
  useEffect(() => {
    if (niosClassNameId) {
      axios
        .get(`${API_BASE_URL}/niosSubjects?classId=${niosClassNameId}`)
        .then((result) => {
          setAllSubjects(result.data);
        })
        .catch((error) => {
          console.error("Error fetching subjects:", error);
        });
    }
  }, [niosClassNameId]);

  useEffect(() => {
    getClasses();
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!niosClassNameId || !allSubjectsId || !title || !file) {
      alert("Please fill in all fields before submitting.");
      return;
    }

    const formData = new FormData();
    formData.append("subjectId", allSubjectsId);
    formData.append("assignment", title);
    formData.append("assignmentpdfPath", file);
    formData.append("language", language);

    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/niosAssignment`
        : `${API_BASE_URL}/admin/niosAssignment`;

    try {
      const response = await axios.post(
        // `${API_BASE_URL}/admin/niosAssignment`,
        endpoint,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("Response:", response.data);
      alert("Assignment submitted successfully!");

      // Reset form fields
      setNiosClassNameId("");
      setAllSubjectsId("");
      setTitle("");
      setFile(null);
    } catch (error) {
      console.error("Error posting data:", error);
      alert("Failed to submit assignment. Please try again.");
    }
  };

  return (
    <div id="assignment-school-main-container">
      <div className="ass-school-heading-or-btns">
        <h4>School Assignment</h4>
        <div className="ass-school-nav-btns">
          <button>School Assignment</button>
          <button onClick={() => navigate("/student-assignment/all-school")}>
            School All Assignments
          </button>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="assignment-school-inner-container">
          {/* Class Selection */}
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Class</b>
            </label>
            <select
              className="p-2"
              value={niosClassNameId}
              onChange={(e) => setNiosClassNameId(e.target.value)}
              required
            >
              <option value="">--Select Class--</option>
              {niosClassName.map((item, idx) => (
                <option value={item._id} key={idx}>
                  {item.className}
                </option>
              ))}
            </select>
          </div>

          {/* Subject Selection */}
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Subject</b>
            </label>
            <select
              className="p-2"
              value={allSubjectsId}
              onChange={(e) => setAllSubjectsId(e.target.value)}
              required
            >
              <option value="">--Select Subject--</option>
              {allSubjects.map((item, idx) => (
                <option key={idx} value={item._id}>
                  {item.subjectName}
                </option>
              ))}
            </select>
          </div>

          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Language</b>
            </label>
            <select
              className="p-2"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              required
            >
              <option value="">--Select Language--</option>
              <option value="english">English</option>
              <option value="hindi">Hindi</option>
            </select>
          </div>

          {/* Title Input */}
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Title</b>
            </label>
            <input
              type="text"
              placeholder="Enter Title"
              className="p-2"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          {/* File Upload */}
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>File</b>
            </label>
            <input
              type="file"
              className="p-2 border"
              onChange={(e) => setFile(e.target.files[0])}
              required
            />
          </div>
        </div>
        <div className="ass-school-submit-btn">
          <button type="submit" className="blogAddSaveButton">
            Submit Assignment
          </button>
        </div>
      </form>
    </div>
  );
};

export default AssignmentSchool;
